var map = {
	"./auth.json": "../../packages/i18n/src/zh_CN/auth.json",
	"./banners.json": "../../packages/i18n/src/zh_CN/banners.json",
	"./business-meta.json": "../../packages/i18n/src/zh_CN/business-meta.json",
	"./chat/common.json": "../../packages/i18n/src/zh_CN/chat/common.json",
	"./chat/list.json": "../../packages/i18n/src/zh_CN/chat/list.json",
	"./chat/message.json": "../../packages/i18n/src/zh_CN/chat/message.json",
	"./company/admin.json": "../../packages/i18n/src/zh_CN/company/admin.json",
	"./company/common.json": "../../packages/i18n/src/zh_CN/company/common.json",
	"./company/create.json": "../../packages/i18n/src/zh_CN/company/create.json",
	"./company/options.json": "../../packages/i18n/src/zh_CN/company/options.json",
	"./company/page.json": "../../packages/i18n/src/zh_CN/company/page.json",
	"./company/users.json": "../../packages/i18n/src/zh_CN/company/users.json",
	"./errors.json": "../../packages/i18n/src/zh_CN/errors.json",
	"./group-preview.json": "../../packages/i18n/src/zh_CN/group-preview.json",
	"./landing/companies.json": "../../packages/i18n/src/zh_CN/landing/companies.json",
	"./landing/driver.json": "../../packages/i18n/src/zh_CN/landing/driver.json",
	"./landing/exchange.json": "../../packages/i18n/src/zh_CN/landing/exchange.json",
	"./landing/meta.json": "../../packages/i18n/src/zh_CN/landing/meta.json",
	"./landing/private_exchange.json": "../../packages/i18n/src/zh_CN/landing/private_exchange.json",
	"./landing/shared.json": "../../packages/i18n/src/zh_CN/landing/shared.json",
	"./layout.json": "../../packages/i18n/src/zh_CN/layout.json",
	"./modals.json": "../../packages/i18n/src/zh_CN/modals.json",
	"./offer/actions.json": "../../packages/i18n/src/zh_CN/offer/actions.json",
	"./offer/exchange.json": "../../packages/i18n/src/zh_CN/offer/exchange.json",
	"./offer/form/cargo.json": "../../packages/i18n/src/zh_CN/offer/form/cargo.json",
	"./offer/form/common.json": "../../packages/i18n/src/zh_CN/offer/form/common.json",
	"./offer/form/options.json": "../../packages/i18n/src/zh_CN/offer/form/options.json",
	"./offer/form/transport.json": "../../packages/i18n/src/zh_CN/offer/form/transport.json",
	"./offer/matches.json": "../../packages/i18n/src/zh_CN/offer/matches.json",
	"./offer/my.json": "../../packages/i18n/src/zh_CN/offer/my.json",
	"./offer/own.json": "../../packages/i18n/src/zh_CN/offer/own.json",
	"./offer/preview.json": "../../packages/i18n/src/zh_CN/offer/preview.json",
	"./offer/shared.json": "../../packages/i18n/src/zh_CN/offer/shared.json",
	"./offer/view.json": "../../packages/i18n/src/zh_CN/offer/view.json",
	"./placeholders.json": "../../packages/i18n/src/zh_CN/placeholders.json",
	"./profile/black_list.json": "../../packages/i18n/src/zh_CN/profile/black_list.json",
	"./profile/contact_list.json": "../../packages/i18n/src/zh_CN/profile/contact_list.json",
	"./profile/edit_profile.json": "../../packages/i18n/src/zh_CN/profile/edit_profile.json",
	"./profile/fill_profile.json": "../../packages/i18n/src/zh_CN/profile/fill_profile.json",
	"./profile/my_profile.json": "../../packages/i18n/src/zh_CN/profile/my_profile.json",
	"./profile/my_profile_auth.json": "../../packages/i18n/src/zh_CN/profile/my_profile_auth.json",
	"./profile/profile_form.json": "../../packages/i18n/src/zh_CN/profile/profile_form.json",
	"./profile/shared.json": "../../packages/i18n/src/zh_CN/profile/shared.json",
	"./profile/short_profile.json": "../../packages/i18n/src/zh_CN/profile/short_profile.json",
	"./shared.json": "../../packages/i18n/src/zh_CN/shared.json",
	"./ui.json": "../../packages/i18n/src/zh_CN/ui.json",
	"./validation.json": "../../packages/i18n/src/zh_CN/validation.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../packages/i18n/src/zh_CN sync recursive \\.json$";